import React from 'react';
import Button from '#lib/components/button.jsx';
import { addClasses, cn } from '#lib/helpers/class.js';
import FloatingTooltip from '#components/tooltip.jsx';
import { Icon } from '@iconify-icon/react';
import { isoDateTimeToString } from '#lib/utils/string.js';
import { Link } from 'react-router-dom';
import { LoadingIndicator } from '#lib/components/loading.jsx';
import { calcExpirationDate, msToMonths } from '#routes/settings/billing/billing-helpers.js';

export function DashboardTable({ headings, items, type, to, isLoading }) {
    const [hoveredIndex, setHoveredIndex] = React.useState(null);

    if (isLoading) {
        return (
            <div className=" w-full md:w-1/3 md:h-full flex justify-center items-center md:shadow-lg md:rounded-xl">
                <LoadingIndicator />
            </div>
        );
    }
    return (
        <div className="w-full md:w-1/3 md:h-full flex flex-col gap-2 p-3 md:shadow-lg md:rounded-xl border-b border-b-neutral-200 md:border-none">
            <h2 className="font-bold text-left text-lg">{_t.home[`last${type}`]()}</h2>
            {items && items.length > 0 ? (
                <div className="contents">
                    <div className="flex flex-col flex-grow gap-2">
                        {type === 'Credits'
                            ? items?.map((purchase) => {
                                  const expirationDate = calcExpirationDate(purchase.datePurchase);
                                  const now = new Date().getTime();
                                  const months = msToMonths(expirationDate - now);
                                  const state = months < 0 ? 'expired' : months < 1 ? 'expiring' : 'valid';
                                  const color = months < 0 ? 'red' : months < 1 ? 'amber' : 'primary';
                                  return (
                                      <div key={purchase.id} id={purchase.id} className="contents text-sm text-left">
                                          <span className="border border-neutral-200 font-semibold p-[6px]">
                                              {purchase.packageId}
                                          </span>
                                          <span className="border border-neutral-200 p-[6px]">
                                              {purchase.creditsNumber}
                                          </span>
                                          <div className="border border-neutral-200 flex items-center justify-between p-[6px]">
                                              <span>{isoDateTimeToString(expirationDate)}</span>
                                              <FloatingTooltip content={state} placement="top">
                                                  <div className={`w-4 h-4 bg-${color}-500 rounded-[50%]`}></div>
                                              </FloatingTooltip>
                                          </div>
                                      </div>
                                  );
                              })
                            : items?.map((itinerary, index) => {
                                  const isHovered = hoveredIndex === index;
                                  return (
                                      <Link to={`/manage/itinerary/edit/${itinerary.id}`} key={index}>
                                          <div
                                              className={cn(
                                                  'flex justify-between items-center rounded-lg py-1 px-2',
                                                  isHovered && 'bg-primary-50 text-primary-600'
                                              )}
                                              onMouseOver={() => setHoveredIndex(index)}
                                              onMouseOut={() => setHoveredIndex(null)}
                                          >
                                              <span
                                                  className={cn(
                                                      'italic text-neutral-900 text-ellipsis truncate whitespace-nowrap',
                                                      isHovered && 'text-primary-600'
                                                  )}
                                              >
                                                  {itinerary.title}
                                              </span>
                                              <Icon
                                                  icon="line-md:arrow-small-right"
                                                  width="1.4rem"
                                                  height="1.4rem"
                                                  className={cn(isHovered && 'text-primary-600')}
                                              />
                                          </div>
                                      </Link>
                                  );
                              })}
                    </div>
                    <Link className="w-fit" to={to}>
                        <Button look="primary" type="submit" className={addClasses('w-full')}>
                            <React.Fragment>
                                <span>{_t.home[`last${type}`]()}</span>
                            </React.Fragment>
                            <Icon
                                icon="line-md:arrow-small-right"
                                width="1.4rem"
                                height="1.4rem"
                                className="ml-2 pt-1"
                            />
                        </Button>
                    </Link>
                </div>
            ) : (
                <section className="h-full relative">
                    <div className="absolute top-0 left-0 w-full h-full bg-neutral-100 flex flex-col justify-center items-center rounded-lg gap-5">
                        <p className="w-2/3 text-center text-neutral-700 italic font-semibold">
                            {_t.home.noItineraries()}
                        </p>
                        <Link to="/manage/itinerary/add">
                            <Button>
                                <span>{_t.home.callToBtn()}</span>
                                <Icon
                                    icon="line-md:arrow-small-right"
                                    width="1.4rem"
                                    height="1.4rem"
                                    className="ml-2 pt-1"
                                />
                            </Button>
                        </Link>
                    </div>
                </section>
            )}
        </div>
    );
}
